export const languages = [
  { title: "English", code: "en" },
  { title: "Hindi - हिंदी", code: "hi" },
  { title: "Spanish - Español", code: "es" },
  { title: "French - Français", code: "fr" },
  { title: "German - Deutsch", code: "de" },
  { title: "Chinese - 中文", code: "zh" },
  { title: "Japanese - 日本語", code: "ja" },
  { title: "Korean - 한국어", code: "ko" },
  { title: "Arabic - العربية", code: "ar" },
  { title: "Russian - Русский", code: "ru" },
  { title: "Portuguese - Português", code: "pt" },
  { title: "Italian - Italiano", code: "it" },
  { title: "Bengali - বাংলা", code: "bn" },
  { title: "Urdu - اردو", code: "ur" },
  { title: "Tamil - தமிழ்", code: "ta" },
  { title: "Telugu - తెలుగు", code: "te" },
  { title: "Marathi - मराठी", code: "mr" },
  { title: "Gujarati - ગુજરાતી", code: "gu" },
  { title: "Punjabi - ਪੰਜਾਬੀ", code: "pa" },
  { title: "Malayalam - മലയാളം", code: "ml" },
  { title: "Thai - ไทย", code: "th" },
  { title: "Turkish - Türkçe", code: "tr" },
  { title: "Vietnamese - Tiếng Việt", code: "vi" },
  { title: "Swahili - Kiswahili", code: "sw" },
  { title: "Greek - Ελληνικά", code: "el" },
  { title: "Hebrew - עברית", code: "he" },
  { title: "Dutch - Nederlands", code: "nl" },
  { title: "Polish - Polski", code: "pl" },
  { title: "Czech - Čeština", code: "cs" },
  { title: "Hungarian - Magyar", code: "hu" },
  { title: "Swedish - Svenska", code: "sv" },
  { title: "Norwegian - Norsk", code: "no" },
  { title: "Danish - Dansk", code: "da" },
  { title: "Finnish - Suomi", code: "fi" },
  { title: "Filipino - Tagalog", code: "tl" },
  { title: "Indonesian - Bahasa Indonesia", code: "id" },
];
